import { createSvgIcon } from '@mui/material';

export const TimeIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="m15.2152 15.8957.6805-.6805-3.2569-3.9375-.4861-4.47225h-.9723l-.4861 5.24995 4.5209 3.8403Zm-3.5486 5.4931c-1.3449 0-2.60884-.2552-3.79171-.7656-1.18287-.5105-2.2118-1.2032-3.0868-2.0782-.875-.875-1.56771-1.9039-2.07813-3.0868-.51042-1.1828-.76562-2.4467-.76562-3.7916s.2552-2.60884.76562-3.79171c.51042-1.18287 1.20313-2.2118 2.07813-3.0868.875-.875 1.90393-1.56771 3.0868-2.07813 1.18287-.51042 2.44681-.76562 3.79171-.76562s2.6088.2552 3.7916.76562c1.1829.51042 2.2118 1.20313 3.0868 2.07813.875.875 1.5677 1.90393 2.0782 3.0868.5104 1.18287.7656 2.44681.7656 3.79171s-.2552 2.6088-.7656 3.7916c-.5105 1.1829-1.2032 2.2118-2.0782 3.0868-.875.875-1.9039 1.5677-3.0868 2.0782-1.1828.5104-2.4467.7656-3.7916.7656Z"
    />
  </svg>,
  'TimeIcon',
);
